<div class="wizard-container">

    <!-- ── STEP 1: Upload ─────────────────────────────────────────────────── -->
    <div class="wizard-step" *ngIf="step === 'upload'">
        <div class="wizard-header">
            <button class="close-btn" (click)="close()" title="Close">✕</button>
            <div class="wizard-title">
                <div class="wizard-icon">📸</div>
                <div>
                    <h2>Upload Your Image</h2>
                    <p class="wizard-subtitle">Your photo will be printed on the poster</p>
                </div>
            </div>
        </div>

        <div class="drop-zone"
            [class.drag-over]="isDragOver"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="openFilePicker()">

            <input #fileInput type="file" accept="image/jpeg, image/png" class="hidden-input" (change)="onFileChange($event)">

            <div class="drop-icon">🖼️</div>
            <p class="drop-text">Drag & drop your photo here</p>
            <p class="drop-hint">or click to browse</p>
            <p class="drop-formats">JPEG, PNG – max 20 MB</p>
        </div>

        <p class="upload-error" *ngIf="uploadError">{{ uploadError }}</p>
    </div>

    <!-- ── STEP 2: Alignment ───────────────────────────────────────────────── -->
    <div class="wizard-step align-step" *ngIf="step === 'align'">
        <div class="wizard-header">
            <button class="close-btn" (click)="close()" title="Close">✕</button>
            <div class="wizard-title">
                <div class="wizard-icon">🎯</div>
                <div>
                    <h2>Position Your Image <span *ngIf="size" class="size-display">({{ size }} cm)</span></h2>
                    <p class="wizard-subtitle">Drag to move · Use slider to zoom</p>
                </div>
            </div>
        </div>

        <!-- Alignment canvas -->
        <div class="ace-wizard-drag-area" #dragAreaElement>
            <img class="wizard-poster-image" #posterImageElement
                [src]="imagePreviewUrl"
                [style.transform-origin]="'top left'"
                alt="Upload preview" />
            <div class="poster-overlay">
                <div class="outside"></div>
                <div class="size-border" #sizeBorderElement
                    [ngStyle]="{'aspect-ratio': availableSizes[size]?.width + ' / ' + availableSizes[size]?.height}">
                    <div class="frame-label">Print area</div>
                </div>
                <div class="outside"></div>
            </div>
        </div>

        <!-- Scale Slider -->
        <div class="scale-row">
            <span class="scale-label">🔍 Zoom</span>
            <input class="scale-slider" type="range"
                [min]="minScale" [max]="maxScale" [step]="0.05"
                [(ngModel)]="scale"
                (input)="onScaleChange(+$any($event.target).value)" />
            <span class="scale-value">{{ (scale * 100).toFixed(0) }}%</span>
        </div>

        <p class="align-hint">The framed area shows exactly what will be printed.</p>

        <p class="confirm-error" *ngIf="confirmError">{{ confirmError }}</p>

        <div class="wizard-footer two-cols">
            <button class="btn btn-secondary" (click)="backToUpload()">← Back</button>
            <button class="btn btn-primary" [disabled]="uploading" (click)="confirm()">
                <span *ngIf="!uploading">✓ Confirm &amp; Continue</span>
                <span *ngIf="uploading" class="spinner-sm"></span>
            </button>
        </div>
    </div>

</div>